import React from 'react';
import { useTranslation } from 'react-i18next';

const STYLES: Record<string, string> = {
  synced: 'bg-green-100 text-green-800',
  failed: 'bg-red-100 text-red-800',
  needs_update: 'bg-orange-100 text-orange-800',
  pending: 'bg-yellow-100 text-yellow-800',
};

const SyncBadge: React.FC<{ status: string; className?: string }> = ({ status, className = '' }) => {
  const { t } = useTranslation();
  const key = ['synced', 'failed', 'needs_update', 'pending'].includes(status) ? status : 'pending';
  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${STYLES[key]} ${className}`}>
      {t(`sync.${key}`)}
    </span>
  );
};

export default SyncBadge;
